module.exports = __webpack_public_path__ + "static/media/1.25d588c3.jpg";